<template>
  <v-container fluid>
    <v-card outlined>
      <v-card-title>
        Resultado de operación
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <thead>
          <tr>
            <th>Producto</th>
            <th>NC</th>
            <th>Stock Inicial</th>
            <th>Cambio</th>
            <th>Stock Final</th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="(item,index) in getItems" :key="index">
            <td>{{item.product.name}}</td>
            <td>{{item.product.shortName}}</td>
            <td>{{item.initialQuantity}}</td>
            <td>{{item.operator}}{{item.changeQuantity}}</td>
            <td>{{item.finalQuantity}}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>

  </v-container>
</template>

<script>
export default {
  name: "StockResult",
  props: {
    addTransaction: {type: Object},
    removeTransaction: {type: Object},
  },
  computed: {
    getItems(){
      let items = []

      if(this.addTransaction){
        for(let item of this.addTransaction.items){
          items.push({
            operator: '+',
            product: item.product,
            initialQuantity: item.initialQuantity,
            changeQuantity: item.changeQuantity,
            finalQuantity: item.finalQuantity,
          })
        }
      }

      if(this.removeTransaction){
        for(let item of this.removeTransaction.items){
          items.push({
            operator: '-',
            product: item.product,
            initialQuantity: item.initialQuantity,
            changeQuantity: item.changeQuantity,
            finalQuantity: item.finalQuantity,
          })
        }
      }

      return items
    }
  }
}
</script>

<style scoped>

</style>
